import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1250px;
  display: flex;
  overflow-x: auto;
  flex-direction: column;

  h1 {
    text-align: left;
    margin-bottom: 15px;
    color: #000;
  }

  @media (max-width: 750px) {
    padding: 10px 0;
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 10px;
    }
  }

  .filters-row {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-bottom: 20px;
    background: #fff;
    padding: 20px;
    border-radius: 15px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid #f0f0f0;
    align-items: flex-end;
  }

  /* Estilo Padronizado de Listagem */
  .leads-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    padding: 0 5px;
  }

  .lead-card {
    background: #fff;
    padding: 15px 25px;
    border-radius: 12px;
    border: 1px solid #f0f0f0;
    display: grid;
    grid-template-columns: 1.5fr 1fr 1fr 1fr 1fr 60px;
    gap: 15px;
    align-items: center;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
    width: 100%;

    &:hover {
      border-color: #008037;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      transform: translateX(5px);
    }

    @media (max-width: 1100px) {
      grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
      gap: 15px;
      padding: 20px;
    }

    .main-info {
      display: flex;
      width: 280px;
      flex-direction: column;
      strong {
        font-size: 15px;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 5px;
      }
      span {
        font-size: 12px;
        color: #008037;
        font-weight: 700;
      }
    }

    .info-item {
      display: flex;
      flex-direction: column;
      font-size: 13px;
      color: #666;
      label {
        font-size: 10px;
        text-transform: uppercase;
        color: #bbb;
        margin-bottom: 2px;
        font-weight: 500;
      }
      span {
        font-weight: 600;
        color: #444;
      }
    }

    .status-badge {
      padding: 5px 12px;
      border-radius: 50px;
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      text-align: center;
      width: fit-content;
      background: #f0f0f0;
      color: #666;
      border: 1px solid #d9d9d9;

      &.fechado {
        background: #f6ffed;
        color: #52c41a;
        border: 1px solid #b7eb8f;
      }
      &.perdido {
        background: #fff1f0;
        color: #f5222d;
        border: 1px solid #ffa39e;
      }
      &.oportunidade {
        background: #e6f7ff;
        color: #1890ff;
        border: 1px solid #91d5ff;
      }
    }

    .actions {
      display: flex;
      justify-content: flex-end;
      gap: 10px;

      button {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        padding: 0 !important;
      }
    }
  }
`;

export const ContainerLead = styled.div`
  position: relative;
  background: #fff;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 8px 15px 5px 15px;
  box-shadow: 0 1px 4px 0 rgba(192, 208, 230, 0.8);
  border-top: 25px solid rgba(230, 236, 245, 0.4);

  header {
    position: absolute;
    top: -20px;
    left: 15px;
    display: flex;
    align-items: center;

    p {
      margin-left: 5px;
      font-size: 12px;
      font-weight: 500;
      color: #000a;
      line-height: 12px;
    }
  }

  p {
    font-weight: 500;
    line-height: 20px;
  }
`;

export const Label = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 2px;
  display: inline-block;
  background: ${(props) => props.color};
`;

export const AssociateInfo = styled.div`
  background: #f8faf9;
  border: 1px solid #d7f0db;
  border-radius: 10px;
  padding: 15px;
  margin-top: 20px;
  display: flex;
  gap: 15px;
  align-items: center;

  img {
    width: 60px !important;
    height: 60px !important;
    border-radius: 8px !important;
    object-fit: cover;
    margin: 0 !important;
  }

  .info {
    display: flex;
    flex-direction: column;

    strong {
      font-size: 14px;
      color: #333;
    }
    span {
      font-size: 12px;
      color: #666;
    }
  }
`;

export const InfoTag = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 15px 0;

  .tag {
    background: #f0f0f0;
    padding: 4px 12px;
    border-radius: 50px;
    font-size: 11px;
    color: #555;
    border: 1px solid #e0e0e0;
    display: flex;
    align-items: center;
    gap: 5px;
  }
`;
